import { IAccountMenuItem } from '@qima-labs/app/pages/account/shared/models/interfaces/account-menu-item.interface';
import { HeaderService } from '@qima-labs/app/pages/main/shared/components/header/shared/service/header.service';
import { IUser } from '@qsp-ui-library/models/interfaces/user.interface';
import { QimaIconService } from '@qsp-ui-library/services/exported-services/qima-icon/qima-icon.service';
import { QimaShadowService } from '@qsp-ui-library/services/exported-services/qima-shadow/qima-shadow.service';
import { QimaTooltipService } from '@qsp-ui-library/services/exported-services/qima-tooltip/qima-tooltip.service';
import { AppAuthenticationService } from '@qsp-ui-library/services/user-services/app-authentication/app-authentication.service';
import { AppUserSettingService } from '@qsp-ui-library/services/user-services/app-user-setting/app-user-setting.service';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { QimaAutoTooltipDirectiveModule, QimaIconModule, QimaShadowDirectiveModule } from '@qima/ngx-qima';

@Component({
  selector: 'app-account-menu',
  templateUrl: './account-menu.component.html',
  styleUrls: ['./account-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, QimaShadowDirectiveModule, QimaAutoTooltipDirectiveModule, QimaIconModule, TranslateModule],
})
export class AccountMenuComponent implements OnInit {
  public currentUser: IUser = this._appAuthenticationService.getCurrentUser();

  public profileMenuItems: IAccountMenuItem[] = [
    {
      label: 'APP_HEADER.ACCOUNT.MY_ACCOUNT',
      path: '/account/access-credentials',
    },
    {
      label: 'APP_HEADER.ACCOUNT.PREFERENCES',
      path: '/account/booking-preferences',
    },
    {
      label: 'APP_HEADER.ACCOUNT.DOCUMENTS',
      path: '/account/my-documents',
    },
  ];

  public constructor(
    private readonly _headerService: HeaderService,
    private readonly _appAuthenticationService: AppAuthenticationService,
    private readonly _router: Router,
    private readonly _appUserSettingService: AppUserSettingService,
    public readonly shadowService: QimaShadowService,
    public readonly qimaTooltip: QimaTooltipService,
    public readonly qimaIcon: QimaIconService
  ) {}

  public ngOnInit(): void {
    this._initData();
  }

  public onAccountMenuItemClick(item: IAccountMenuItem): void {
    this._closeMenu();

    void this._router.navigateByUrl(item.path);
  }

  public logout(): void {
    this._appAuthenticationService.logout();
  }

  private _closeMenu(): void {
    this._headerService.updateIsProfileMenuVisible(false);
  }

  private _initData(): void {
    if (this._appUserSettingService.getIsQimaProduce()) {
      this.profileMenuItems = [this.profileMenuItems[0]];
    }
  }
}
